import type { createApp } from 'vue'
import AlirezaDatePicker from './components/AlirezaDatePicker.vue'
import Badge from './components/Badge.vue'
import Button from './components/Button.vue'
import Checkbox from './components/Checkbox.vue'
import ErrorMessage from './components/ErrorMessage.vue'
import FileUploader from './components/FileUploader.vue'
import Form from './components/Form.vue'
import Input from './components/Input.vue'
import InputWithCounter from './components/InputWithCounter.vue'
import InputWithSelect from './components/InputWithSelect.vue'
import LayoutLoader from './components/LayoutLoader.vue'
import LazyImage from './components/LazyImage.vue'
import Modal from './components/Modal.vue'
import MultiSelect from './components/MultiSelect.vue'
import OffCanvasPanel from './components/OffCanvasPanel.vue'
import Pagination from './components/Pagination.vue'
import PhoneInput from './components/PhoneInput.vue'
import Radio from './components/Radio.vue'
import SegmentedControl from './components/SegmentedControl.vue'
import Select from './components/Select.vue'
import Table from './components/Table.vue'
import Textarea from './components/Textarea.vue'
import Tooltip from './components/Tooltip.vue'

export function setupUi(app: ReturnType<typeof createApp>) {
  app.component('LazyImage', LazyImage)
  app.component('Tooltip', Tooltip)
  app.component('Input', Input)
  app.component('Button', Button)
  app.component('Modal', Modal)
  app.component('Select', Select)
  app.component('Pagination', Pagination)
  app.component('Radio', Radio)
  app.component('Checkbox', Checkbox)
  app.component('Table', Table)
  app.component('AlirezaDatePicker', AlirezaDatePicker)
  app.component('Textarea', Textarea)
  app.component('MultiSelect', MultiSelect)
  app.component('PhoneInput', PhoneInput)
  app.component('ErrorMessage', ErrorMessage)
  app.component('FileUploader', FileUploader)
  app.component('OffCanvasPanel', OffCanvasPanel)
  app.component('SegmentedControl', SegmentedControl)
  app.component('InputWithSelect', InputWithSelect)
  app.component('InputWithCounter', InputWithCounter)
  app.component('Badge', Badge)

  app.component('LayoutLoader', LayoutLoader)
  app.component('UiForm', Form)
}
